module.exports = {
  'firebase': 'ppa-production',
  'firebaseKey': 'AIzaSyBVE7aWH6W69Tx2cFPkvF_JtyB1ZEJiJW0',
  'intercom': 'qksg3lul',
  'intercomToken': 'dG9rOmY3YTZiZmI5XzliNTBfNDQ2NF9iMDg0XzBhYmNjZDFjYzlmNzoxOjA=',
  'stripe': 'pk_live_gndcHnDE509rtuUYBIjJ67fQ',
  'apiUrl': 'https://api.planetprotectoracademy.com/'
};



// WEBPACK FOOTER //
// ./appConfig.js